import type { ReactNode } from 'react';

interface HBarProps {
  pct: number;
  color: string;
  label: ReactNode;
  value: string;
}

export function HBar({ pct, color, label, value }: HBarProps) {
  return (
    <div className="mb-2.5">
      <div className="mb-1 flex justify-between text-caption-regular">
        <span className="font-medium text-muted-foreground">{label}</span>
        <span className="font-semibold text-foreground">{value}</span>
      </div>
      <div className="h-1.5 overflow-hidden rounded-sm bg-stone-200">
        <div
          className="h-full rounded-sm transition-[width] duration-500 ease-in-out"
          style={{ width: `${pct}%`, background: color }}
        />
      </div>
    </div>
  );
}
